import { takeEvery, all, put, select } from 'redux-saga/effects'

import { getProtrackById } from '../actions'
import { getAllProtracks, fetchPublicProTracks } from 'store/entities/protracks/actions'
import { getProtracksLoadedAll } from 'store/entities/protracks/selectors'

export function* handleGetSuccess() {
  const protracksLoaded = yield select(getProtracksLoadedAll)
  if (!protracksLoaded) {
    yield put(getAllProtracks())
  }
  yield fetchPublicProTracks.call()
}

export default function* unsubscribeProgressSaga() {
  yield all([takeEvery(getProtrackById.success.toString(), handleGetSuccess)])
}
